import { ActionTree } from "vuex";
import { RootState } from "../types/RootState";
import { PointState } from "../types/PointState";

import { repositories } from '../../api/Repositories';
import { RepositoryFabric } from "../../../api/repositories/RepositoryFabric";
import { PointRepository } from "../../../api/repositories/PointRepository";
import { QueryParametersInterface } from "@api/repositories/interfaces/QueryParametersInterface";
import { groupFilter } from "../../../api/helpers/groupFilter";

export const actions: ActionTree<PointState, RootState> = {
    async update({ commit, dispatch, rootState, rootGetters }) {
        if (!document.hidden) {        
            const params = rootGetters['events/selectedEventViewParam']('participants', null),
                groupIds = params?.groupIds || rootState.session.profile?.groupIds || [],
                query: QueryParametersInterface = {
                    where: {
                        userId: rootState.session.userId,
                        ...groupFilter(groupIds)
                    },
                    take: 1
                };
            try {
                const myPoints = await (repositories.get(RepositoryFabric.POINT) as PointRepository).query(query, groupIds);
                if (myPoints.length) {
                    commit('setPoints', myPoints[0]);
                }
            } catch (e) {
                dispatch('reportError', e, {root: true});
            }
        }
    },
    async startTracking({commit, dispatch}) {
        await dispatch('update');

        const updateIntervalId = window.setInterval(() => {
            dispatch('update');
        }, 60000);
        commit('setInterval', updateIntervalId);
    },
    stopTracking({state, commit}) {
        state.updateIntervalId && clearInterval(state.updateIntervalId);
        commit('clearPoints');
        commit('clearInterval');
    },
};

